import React from 'react'
import { OverlayTrigger, Tooltip as TooltipComp } from "react-bootstrap";
import { useIntl } from 'react-intl';

interface TooltipInfoApprovalProps {
    reason: string
}

const TooltipInfoApproval = ({ reason }: TooltipInfoApprovalProps) => {
    const intl = useIntl()

    return (
        <OverlayTrigger
            placement='top'
            overlay={<TooltipComp id='tooltip-labels'>
                {reason ? <span>{intl.formatMessage({ id: 'MEETING.STATUS.REASON' }, { title: reason })}</span> : <span>{intl.formatMessage({ id: 'MEETING.TOOLTIP.INFO_APPROVAL' })}</span>}
            </TooltipComp>}
        >
            <span
                className='cursor-pointer'
                data-toggle='tooltip'
                data-placement='top'
            >
                <i className='fa fa-info-circle'></i>
            </span>
        </OverlayTrigger>
    )
}

export default TooltipInfoApproval